export const LLAVEINTEGRIDAD = 'prod_integrity_Rr6SqIgUoUmUTtnGALMxd08B7oniHLjA'
export const LLAVEPUBLICA = 'pub_prod_EXlOGPeDz5YGv14f3GlgqiuytbX8GyFg'

//export const LLAVEINTEGRIDAD = 'test_integrity_hBuDswptPhXlFZWA7SxApwZfeJCUcNQs' //test
//export const LLAVEPUBLICA = 'pub_test_yD5L6W3P2SW1asyJp7xrRrTEcIXn0PZH' //test


export const MONEDA = 'COP'

export const URLRECIBO = 'https://narinosouvenirs.com/Checkout'

//export const URLRECIBO = 'http://localhost:3000/Recibo' //test

export const URLAPI = 'https://production.wompi.co/v1/transactions/'

//export const URLAPI = 'https://sandbox.wompi.co/v1/transactions/'